import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Divider/Display.tsx
var DividerDisplay = () => {
	return /* @__PURE__ */ jsx("hr", {});
};
//#endregion
export { DividerDisplay };

//# sourceMappingURL=Display.js.map